import createReducer from '../createReducer';
import {
  SET_WIND_COLORS,
  SET_WIND_ARROW_OPTIONS,
  SET_SWELL_HEIGHT_COLORS,
  SET_SWELL_HEIGHT_ARROW_OPTIONS,
  SET_SWELL_PERIOD_COLORS,
  SET_SWELL_PERIOD_ARROW_OPTIONS,
  OVERWRITE_CHART_CONFIG,
} from '../../actions/charts';

const initialCount = 0;

const handlers = [
  SET_WIND_COLORS,
  SET_WIND_ARROW_OPTIONS,
  SET_SWELL_HEIGHT_COLORS,
  SET_SWELL_HEIGHT_ARROW_OPTIONS,
  SET_SWELL_PERIOD_COLORS,
  SET_SWELL_PERIOD_ARROW_OPTIONS,
  OVERWRITE_CHART_CONFIG,
].reduce((allHandlers, action) => ({
  ...allHandlers,
  [action]: count => count + 1,
}), {});

export default createReducer(handlers, initialCount);



// WEBPACK FOOTER //
// ./src/reducers/charts/designIterations.js